import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Skeleton } from 'components/UnvUI'
import { Button } from '@mui/material'

import $api from 'http/index'
import Notification from 'utils/Notifications'

import styles from './ArchivePage.module.scss'

const fmtDate = (iso) => {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleDateString('ru-RU')
  } catch {
    return '—'
  }
}

const OrderArchiveLinkPage = () => {
  const { t } = useTranslation('common')

  const [orders, setOrders] = useState([])
  const [cases, setCases] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [pickedOrder, setPickedOrder] = useState(null)
  const [pickedCase, setPickedCase] = useState(null)
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const load = async () => {
    setLoading(true)
    setError(false)
    try {
      const [o, c] = await Promise.allSettled([
        $api.get('/students/orders/', { params: { archive_case__isnull: true } }),
        $api.get('/archive/cases/', { params: { unlinked: true } }),
      ])
      if (o.status === 'fulfilled') setOrders(o.value.data?.results || o.value.data || [])
      else setError(true)
      if (c.status === 'fulfilled') setCases(c.value.data?.results || c.value.data || [])
      else setError(true)
    } catch {
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  const link = async () => {
    if (!pickedOrder || !pickedCase) {
      setNotify({ isOpen: true, message: 'Выберите приказ и дело', type: 'warning', sound: 'warning' })
      return
    }
    try {
      await $api.post('/archive/link-order/', {
        order_id: pickedOrder,
        case_id: pickedCase,
      })
      setNotify({ isOpen: true, message: 'Связь установлена', type: 'success', sound: 'success' })
      setPickedOrder(null)
      setPickedCase(null)
      load()
    } catch {
      setNotify({ isOpen: true, message: 'Ошибка', type: 'error', sound: 'error' })
    }
  }

  return (
    <div className={styles.page}>
      <div className={`unv-card ${styles.header}`}>
        <h1 className={styles.title}>{t('archive.link_title_page')}</h1>
        <Button variant="contained" onClick={link} disabled={!pickedOrder || !pickedCase}>
          Связать выбранные
        </Button>
      </div>

      <div className="unv-card">
        {loading ? (
          <div className={styles.loaderWrap}>
            <Skeleton variant="table" rows={5} cols={4} />
          </div>
        ) : error ? (
          <div className="unv-empty">{t('schedule.section_in_dev')}</div>
        ) : (
          <div className={styles.linkGrid}>
            <div className={styles.column}>
              <div className={styles.columnTitle}>{t('archive.unlinked_orders')}</div>
              {orders.length === 0 && <div className="unv-empty">{t('archive.list_empty')}</div>}
              {orders.map((o) => (
                <div
                  key={o.id}
                  className={`${styles.linkRow} ${pickedOrder === o.id ? styles.linkRowActive : ''}`}
                  onClick={() => setPickedOrder(o.id)}
                >
                  <div>
                    <div>
                      <strong>№{o.number || o.id}</strong> — {o.kind || o.type || '—'}
                    </div>
                    <div style={{ color: '#888', fontSize: 12 }}>
                      {fmtDate(o.signed_at || o.created_at)} · {o.subject_full_name || ''}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.linkActions}>
              <Button variant="contained" onClick={link} disabled={!pickedOrder || !pickedCase}>
                Связать
              </Button>
            </div>
            <div className={styles.column}>
              <div className={styles.columnTitle}>{t('archive.unlinked_cases')}</div>
              {cases.length === 0 && <div className="unv-empty">{t('archive.list_empty')}</div>}
              {cases.map((c) => (
                <div
                  key={c.id}
                  className={`${styles.linkRow} ${pickedCase === c.id ? styles.linkRowActive : ''}`}
                  onClick={() => setPickedCase(c.id)}
                >
                  <div>
                    <div>
                      <strong>{c.number || `Дело №${c.id}`}</strong> — {c.title || '—'}
                    </div>
                    <div style={{ color: '#888', fontSize: 12 }}>
                      {fmtDate(c.opened_at || c.created_at)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default OrderArchiveLinkPage
